var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.46447 15.4643C5.40215 14.5267 6.67392 13.9999 8 13.9999H16C17.3261 13.9999 18.5979 14.5267 19.5355 15.4643C20.4732 16.402 21 17.6738 21 18.9999V20.9999C21 21.5522 20.5523 21.9999 20 21.9999C19.4477 21.9999 19 21.5522 19 20.9999V18.9999C19 18.2042 18.6839 17.4412 18.1213 16.8786C17.5587 16.3159 16.7956 15.9999 16 15.9999H8C7.20435 15.9999 6.44129 16.3159 5.87868 16.8786C5.31607 17.4412 5 18.2042 5 18.9999V20.9999C5 21.5522 4.55228 21.9999 4 21.9999C3.44772 21.9999 3 21.5522 3 20.9999V18.9999C3 17.6738 3.52678 16.402 4.46447 15.4643Z",
    fill: "#888888"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 3.99988C10.3433 3.99988 9.00012 5.34302 9.00012 6.99988C9.00012 8.65673 10.3433 9.99988 12.0001 9.99988C13.657 9.99988 15.0001 8.65673 15.0001 6.99988C15.0001 5.34302 13.657 3.99988 12.0001 3.99988ZM7.00012 6.99988C7.00012 4.23845 9.2387 1.99988 12.0001 1.99988C14.7615 1.99988 17.0001 4.23845 17.0001 6.99988C17.0001 9.7613 14.7615 11.9999 12.0001 11.9999C9.2387 11.9999 7.00012 9.7613 7.00012 6.99988Z",
    fill: "#888888"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonOutline);
export default __webpack_public_path__ + "static/media/person-outline.de41f08d.svg";
export { ForwardRef as ReactComponent };